import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

export default async function ToggleWishedTradingPhotoCard(tradingPhotoCardId, wished) {
  return fetch(
    `${baseUrl()}/trading_photo_cards/${tradingPhotoCardId}/${wished ? 'unwished' : 'wished'}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      }
    }
  );
}
